'use client';

import { Flex, Text } from '@chakra-ui/react';
import { PLANS } from '@features/onboarding/plans';
import { observer } from 'mobx-react-lite';
import { useOnboardingStore } from 'stores/rootStore';

const ChoosePlanStepTitle = () => {
  const onboardingStore = useOnboardingStore();
  const selectedPlan = PLANS.find((p) => p.key === onboardingStore.selectedPlanKey);
  const selectedPlanName = selectedPlan?.name;

  return (
    <Flex flexDirection="column">
      <Text>Choose plan</Text>
      {selectedPlanName != null && (
        <Text fontSize="xs" color="text.secondary" fontWeight="normal">
          {selectedPlanName}
        </Text>
      )}
    </Flex>
  );
};

export default observer(ChoosePlanStepTitle);
